<script>
  import { meta, entityData } from "./store.js";

  export let entities;
  let value = entities.join("\n");

  function onOk() {
    if ($meta.inputOpen) {
      entities = value
        .split(/,|\n/)
        .map(s => s.trim())
        .filter(a => a)
        .sort();
      value = entities.join("\n");
    }
    $meta.inputOpen = !$meta.inputOpen;
  }

  let laps = "50";
  $: $meta.laps = parseInt(laps);

  function reset() {
    $entityData = {};
    $meta = { inputOpen: true, laps: 50 };
    value = "";
    entities = [];
  }

  function startStop() {
    if (!$meta.stopwatch) {
      $meta.stopwatch = { start: new Date().getTime(), state: "RUN" };
    } else if ($meta.stopwatch.state === "STOP") {
      $meta.stopwatch = { ...$meta.stopwatch, state: "RUN" };
    } else {
      $meta.stopwatch = {
        ...$meta.stopwatch,
        end: new Date().getTime(),
        state: "STOP"
      };
    }
  }
</script>

<style>
  .wrap {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .side-ctl {
    margin: 0rem 1rem;
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin: 0px;
    margin-top: 1rem;
    gap: 1rem;
  }
  textarea {
    height: 200px;
  }
  select,
  button {
    padding: 0.4rem;
    border: 0px;
  }
</style>

<div class="wrap">
  {#if $meta.inputOpen}
    <p>Enter names separated by comma and/or newlines.</p>
    <textarea bind:value={value}></textarea>
  {/if}
  <div class="side-ctl">
  {#if $meta.inputOpen}
  <select bind:value={laps}>
    <option value="16">Lap Length: 16m</option>
    <option value="25">Lap Length: 25m</option>
    <option value="33">Lap Length: 33m</option>
    <option value="50">Lap Length: 50m</option>
    <option value="100">Lap Length: 100m</option>
    <option value="200">Lap Length: 200m</option>
  </select>
  <button on:click={reset}>Reset</button>
  {/if}
  <button on:click={() => onOk()}>
    {#if $meta.inputOpen}
      Done
    {:else}
      Edit
    {/if}
  </button>

  {#if !$meta.inputOpen}
    <button on:click={startStop}>
      {#if !$meta.stopwatch}
        Start
      {:else if $meta.stopwatch.state === "STOP"}
        Continue
      {:else}
        Stop
      {/if}
    </button>
  {/if}
  </div>
</div>

